import React, { FC } from 'react';

import MainLayout from './MainLayout';
import { ProtectedRoute } from './ProtectedRoute';

type AdminPageProps = {
  Component: FC;
  permission?: string;
};

const AdminPage: FC<AdminPageProps> = ({ Component, permission }) => (
  <MainLayout>
    <ProtectedRoute permission={permission}>
      <Component />
    </ProtectedRoute>
  </MainLayout>
);

export default AdminPage;
